<template>
  <div class="login">
    <div class="login-overlay"></div>
    <div class="_box">
      <div class="_left">
        <img alt="" src="~@/assets/image/login-box-left.svg" srcset="" />
      </div>
      <div class="_right">
        <div class="_top">
          <img alt="" class="_l" src="~@/assets/image/logo.png" srcset="" />
          <div class="_brand">
            <div class="_name">维特沃斯</div>
            <div class="_r">ERP 后台管理系统</div>
          </div>
        </div>
        <div class="_title">账户密码登录</div>
        <div class="_subtitle">请输入账号信息以继续</div>
        <a-form-model
          ref="ruleForm"
          :model="form"
          :rules="rules"
          class="login-form"
        >
          <a-form-model-item ref="username" prop="username">
            <a-input
              v-model="form.username"
              allow-clear
              placeholder="用户名"
              size="large"
              @blur="
                () => {
                  $refs.username.onFieldBlur()
                }
              "
              @keyup.enter="onSubmit"
            >
              <a-icon slot="prefix" type="user" />
            </a-input>
          </a-form-model-item>
          <a-form-model-item ref="password" prop="password">
            <a-input
              v-model="form.password"
              allow-clear
              placeholder="密码"
              size="large"
              type="password"
              @blur="
                () => {
                  $refs.password.onFieldBlur()
                }
              "
              @keyup.enter="onSubmit"
            >
              <a-icon slot="prefix" type="lock" />
            </a-input>
          </a-form-model-item>

          <a-form-model-item class="remember" prop="remember">
            <a-checkbox-group v-model="form.remember">
              <a-checkbox :value="true" name="true">
                自动登录
              </a-checkbox>
            </a-checkbox-group>
          </a-form-model-item>
          <a-form-model-item class="loginwrapper">
            <a-button
              :loading="loading"
              class="login-btn"
              type="primary"
              @click="onSubmit"
            >
              <span v-if="!loading">登 录</span>
              <span v-else>登 录 中...</span>
            </a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
    </div>
    <div class="label">
      CopyRight2023 版权所有
      <a @click="toWebsite">http://qdwtws.com/</a> 维特沃斯 值得信赖
    </div>
  </div>
</template>
<script>
import storage from "store"
import md5 from "js-md5"
import { defaultPassWord } from "@/config"

export default {
  data() {
    return {
      identifycode: "",
      redirect: undefined,
      form: {
        username: "",
        password: "",
        remember: []
      },
      loading: false,
      rules: {
        username: [
          {
            required: true,
            message: "请输入账号/用户名",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur"
          }
        ]
      }
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  created() {
    this.getCookie()
  },
  methods: {
    getCookie() {
      const username = storage.get("username")
      const password = storage.get("password")
      const remember = storage.get("remember")

      this.form = {
        username: username === undefined ? this.form.username : username,
        password: password,
        remember:
          remember === undefined
            ? []
            : Boolean(remember) === false
            ? []
            : [Boolean(remember)]
      }
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        const user = {
          username: this.form.username,
          password: this.form.password,
          remember: this.form.remember
        }
        user.password = md5(md5(user.password) + "wtws")
        if (valid) {
          this.loading = true

          if (user.remember.length && user.remember[0]) {
            storage.set("username", user.username)
            storage.set("password", this.form.password)
            storage.set(
              "remember",
              user.remember[0] === undefined ? false : true
            )
          } else {
            storage.remove("username")
            storage.remove("password")
            storage.remove("remember")
          }
          this.$store
            .dispatch("Login", user)
            .then(res => {
              if (res.code === 0) {
                this.$message.success("登陆成功！")
                if (this.form.password === defaultPassWord) {
                  this.$store.commit("SET_FIRST")
                  this.$router.push({
                    name: "Reset",
                    query: { account: this.form.username }
                  })
                } else {
                  this.$router.push({ path: "/customer/index" })
                }
              }
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          return false
        }
      })
    },

    toWebsite() {
      window.open("http://qdwtws.com/", "_blank")
    }
  }
}
</script>
<style lang="scss" scoped>
.login {
  position: relative;
  min-width: 320px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background: url("~@/assets/image/back-ground1.png") no-repeat 50%;
  background-size: cover;
  box-sizing: border-box;
  overflow: hidden;

  .login-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(
      135deg,
      rgba(11, 46, 94, 0.35) 0%,
      rgba(24, 144, 255, 0.18) 45%,
      rgba(8, 28, 58, 0.4) 100%
    );
    pointer-events: none;
  }

  .label {
    position: absolute;
    bottom: 16px;
    z-index: 2;
    color: rgba(255, 255, 255, 0.85);
    font-size: 13px;
    letter-spacing: 0.3px;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);

    a {
      color: #fff;
      text-decoration: underline;
      margin: 0 4px;
    }
  }

  ._box {
    position: relative;
    z-index: 1;
    width: 1022px;
    min-height: 560px;
    background: rgba(255, 255, 255, 0.96);
    border-radius: 16px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    box-shadow: 0 20px 60px rgba(8, 28, 58, 0.28),
      0 2px 8px rgba(8, 28, 58, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.6);
    backdrop-filter: blur(8px);
    animation: loginFadeIn 0.45s ease;

    ._left {
      img {
        display: block;
        width: 406px;
        height: 406px;
        margin-left: 56px;
        margin-right: 72px;
      }
    }

    ._right {
      flex: 1;
      padding-right: 48px;

      ._top {
        display: flex;
        align-items: center;
        margin-bottom: 36px;

        ._l {
          margin-right: 20px;
          display: block;
          width: 72px;
          height: 72px;
          border-radius: 16px;
          object-fit: contain;
          box-shadow: 0 6px 16px rgba(24, 144, 255, 0.18);
        }

        ._brand {
          ._name {
            font-size: 22px;
            font-weight: 600;
            color: #0b1f3a;
            line-height: 1.2;
            letter-spacing: 1px;
          }

          ._r {
            margin-top: 6px;
            font-size: 14px;
            font-weight: 400;
            color: #1890ff;
            letter-spacing: 0.5px;
          }
        }
      }

      ._title {
        font-size: 20px;
        font-weight: 600;
        text-align: left;
        color: rgba(0, 0, 0, 0.85);
        margin-bottom: 6px;
      }

      ._subtitle {
        font-size: 13px;
        color: rgba(0, 0, 0, 0.45);
        margin-bottom: 24px;
      }

      .login-form {
        width: 360px;

        ::v-deep .ant-input-affix-wrapper {
          padding: 0;
          border: none;
          transition: all 0.2s;

          .ant-input {
            height: 40px;
            border-radius: 8px;
            border: 1px solid #e8ecf1;
            background: #fff;
            transition: all 0.2s;

            &:hover,
            &:focus {
              border-color: #1890ff;
              box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.12);
            }
          }

          &.ant-input-affix-wrapper-focused .ant-input {
            border-color: #1890ff;
            box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.12);
          }
        }

        ::v-deep .ant-input-prefix,
        ::v-deep .ant-checkbox-wrapper {
          color: #8c9aab;
        }

        ::v-deep .ant-input-affix-wrapper .ant-input:not(:first-child) {
          padding-left: 36px;
        }

        ::v-deep .ant-input-affix-wrapper .ant-input:not(:last-child) {
          padding-right: 36px;
        }

        ::v-deep
          .ant-input-affix-wrapper.ant-input-affix-wrapper-input-with-clear-btn
          .ant-input:not(:last-child) {
          padding-right: 49px;
        }

        ::v-deep .ant-form-item {
          &.remember {
            margin-bottom: 20px;

            &.ant-form-item-with-help {
              margin-bottom: 0;
            }
          }

          .login-btn {
            width: 100%;
            height: 46px;
            background: linear-gradient(135deg, #4dabff 0%, #1677ff 100%);
            border-radius: 10px;
            margin: 0;
            border: none;
            line-height: 46px;
            font-size: 16px;
            font-weight: 600;
            letter-spacing: 4px;
            box-shadow: 0 8px 20px rgba(22, 119, 255, 0.35);
            transition: transform 0.15s ease, box-shadow 0.2s ease;

            &:hover,
            &:focus {
              background: linear-gradient(135deg, #69bbff 0%, #1677ff 100%);
              transform: translateY(-1px);
              box-shadow: 0 10px 24px rgba(22, 119, 255, 0.42);
            }

            &:active {
              transform: translateY(0);
            }
          }

          &.loginwrapper {
            .ant-form-item-control-wrapper {
              width: 100%;
            }
          }
        }
      }
    }
  }
}

@keyframes loginFadeIn {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@media (max-width: 1100px) {
  .login {
    padding: 32px;

    ._box {
      width: min(920px, 100%);

      ._left img {
        width: 340px;
        height: 340px;
        margin-left: 36px;
        margin-right: 48px;
      }

      ._right {
        padding-right: 36px;
      }
    }
  }
}

@media (max-width: 820px) {
  .login {
    padding: 24px;

    ._box {
      width: min(480px, 100%);
      min-height: auto;
      padding: 42px;

      ._left {
        display: none;
      }

      ._right {
        padding: 0;

        ._top {
          margin-bottom: 30px;
        }

        .login-form {
          width: 100%;
        }
      }
    }
  }
}

@media (max-width: 520px) {
  .login {
    align-items: flex-start;
    padding: 20px 16px 64px;
    overflow-y: auto;

    ._box {
      margin-top: 5vh;
      padding: 32px 24px;
      border-radius: 14px;

      ._right ._top ._l {
        width: 56px;
        height: 56px;
      }
    }

    .label {
      right: 16px;
      bottom: 12px;
      left: 16px;
      text-align: center;
    }
  }
}
</style>
